<template>
    <div class="login-form">
        <h2 class="login-form__title">Login</h2>

        <form @submit.prevent="loginByPassword" class="login__form">
            <ui-field name="Email">
                <ui-input type="email" v-model="email" />
            </ui-field>

            <ui-field name="Password">
                <ui-input type="password" v-model="password" />
            </ui-field>

            <ui-button type="submit">Zaloguj</ui-button>

        </form>

        <p class="login-form__separator">lub</p>
        <ui-button  @click="loginByFacebook">Zaloguj przez Facebook</ui-button>
    </div>
</template>

<style lang="scss">
    .login-form {
        &__title {
            font-size: 1.2rem;
            margin: 0 0 1em 0;
        }

        &__separator {
            text-align: center;
        }
    }
</style>

<script>
import uiField from '@/components/ui/form/Field.vue';
import uiInput from '@/components/ui/form/Input.vue';
import uiButton from '@/components/ui/Button.vue';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },

  methods: {
    reset() {
      this.password = '';
      this.email = '';
    },

    loginByPassword() {
      this.$emit('loginByPassword', {
        email: this.email,
        password: this.password,
      });
    },

    loginByFacebook() {
      this.$emit('loginByFacebook');
    },
  },

  components: {
    uiField,
    uiInput,
    uiButton,
  },
};
</script>
